import { Button, Container, Grid, Row, Text } from "@nextui-org/react";
import { React, useEffect, useState } from "react";
import { is_kanoodle_solvable, rotate_piece } from "../functions/main";
import kanoodle_pieces from "../models/kanoodle_pieces";

export const KanoodlePieceChooser = ({ setTransformKanoodlePiece }) => {
  const pieces = kanoodle_pieces.Pieces;
  const [piece, setPiece] = useState(0);
  const [rotation, setRotation] = useState(0);
  const [flip, setFlip] = useState(1);
  const [rotatedArray, setRotatedArray] = useState(pieces[piece].Shape);

  const handleSetTransfomrKanoodlePiece = () => {
    let new_piece = { ...pieces[piece] };
    new_piece.Shape = rotatedArray;
    setTransformKanoodlePiece(new_piece);
  };

  useEffect(() => {
    setRotation(0);
    setFlip(1);
    setRotatedArray(pieces[piece].Shape);
  }, [piece, pieces]);

  const handleChangePiece = (forward) => {
    if (forward) {
      setPiece(piece === 11 ? 0 : piece + 1);
    } else {
      setPiece(piece === 0 ? 11 : piece - 1);
    }
  };

  const handleRotatePiece = () => {
    if (rotation === 0) {
      setRotation(90);
    } else if (rotation === 90) {
      setRotation(180);
    } else if (rotation === 180) {
      setRotation(270);
    } else if (rotation === 270) {
      setRotation(0);
    }
    setRotatedArray(rotate_piece(rotatedArray));
  };

  const handleFlipPiece = () => {
    if(flip === -1){
      setFlip(1);
    }
    else if(flip === 1){
      setFlip(-1);
    }

    const flipped_array = rotatedArray.map(x => x.reverse())
    setRotatedArray(flipped_array)
  }

  return (
    <Container>
      <Row justify="center">
        <Button auto onPress={() => handleChangePiece(false)}>
          -
        </Button>
        <img
          height={100}
          src={require(`../images/${pieces[piece].Piece}.png`)}
          alt={pieces[piece].Color}
          style={{
            transform: `rotate(${rotation.toString()}deg) scaleX(${flip.toString()})`,
            display: "block",
            padding: 5,
          }}
        />
        <Button auto onPress={() => handleChangePiece(true)}>
          +
        </Button>
      </Row>
      <Row justify="center">
        <Grid.Container xl gap={1} justify="center">
          <Grid>
            <Button color="secondary" auto onPress={() => handleRotatePiece()}>
              Rotate
            </Button>
          </Grid>
          <Grid>
            <Button color="warning" auto onPress={() => handleFlipPiece()}>
              Flip
            </Button>
          </Grid>
          <Grid>
            <Button auto onPress={() => handleSetTransfomrKanoodlePiece()}>
              Submit
            </Button>
          </Grid>
        </Grid.Container>
      </Row>
    </Container>
  );
};

export const KanoodleBoard = ({ piece }) => {
  const [kanoodleBoard, setKanoodleBoard] = useState(
    handleInitialApplyPieceShapeToKanoodleBoard(piece ? piece.Shape : null)
  );

  const [solvable, setSolvable] = useState(false);
  const [displaySolvableResult, setDisplaySolvableResult] = useState(false);

  const handleRunCalculation = () => {
    setSolvable(is_kanoodle_solvable(kanoodleBoard));
    setDisplaySolvableResult(true)
  }

  const handleMoveUpOnTheKanoodleBoard = () => {
    const new_kanoodle_board = kanoodleBoard.map((x) => x);
    new_kanoodle_board.shift();
    new_kanoodle_board.push(Array(11).fill(0));
    setKanoodleBoard(new_kanoodle_board);
  };

  const handleMoveDownOnTheKanoodleBoard = () => {
    const new_kanoodle_board = kanoodleBoard.map((x) => x);
    new_kanoodle_board.pop();
    new_kanoodle_board.unshift(Array(11).fill(0));
    setKanoodleBoard(new_kanoodle_board);
  };

  const handleMoveLeftOnTheKanoodleBoard = () => {
    const new_kanoodle_board = kanoodleBoard.map((x) => x);
    new_kanoodle_board.forEach(function (row) {
      row.shift();
      row.push(0);
    });
    setKanoodleBoard(new_kanoodle_board);
  };

  const handleMoveRightOnTheKanoodleBoard = () => {
    const new_kanoodle_board = kanoodleBoard.map((x) => x);
    new_kanoodle_board.forEach(function (row) {
      row.pop();
      row.unshift(0);
    });
    setKanoodleBoard(new_kanoodle_board);
  };

  const handleMoveLeftDisabled = () => {
    let leftMostValueExists = false;
    kanoodleBoard?.forEach((row_value, row_index) => {
      row_value.forEach((column_value, column_index) => {
        if (
          column_index === 0 &&
          kanoodleBoard[row_index][column_index] === 1
        ) {
          leftMostValueExists = true;
        }
      });
    });

    return leftMostValueExists;
  };

  const handleMoveRightDisabled = () => {
    let rightMostValueExists = false;
    kanoodleBoard?.forEach((row_value, row_index) => {
      row_value.forEach((column_value, column_index) => {
        if (
          column_index === kanoodleBoard[row_index].length - 1 &&
          kanoodleBoard[row_index][column_index] === 1
        ) {
          rightMostValueExists = true;
        }
      });
    });

    return rightMostValueExists;
  };

  return (
    <Container xl>
      <Grid.Container xl gap={1} justify="center">
        <Grid md={1}>
          <Button
            auto
            disabled={piece?.Shape ? kanoodleBoard[0]?.includes(1) : true}
            onPress={() => handleMoveUpOnTheKanoodleBoard()}
          >
            Up
          </Button>
        </Grid>
        <Grid md={1}>
          <Button
            auto
            disabled={
              piece?.Shape
                ? kanoodleBoard[kanoodleBoard?.length - 1]?.includes(1)
                : true
            }
            onPress={() => handleMoveDownOnTheKanoodleBoard()}
          >
            Down
          </Button>
        </Grid>
        <Grid md={1}>
          <Button
            auto
            disabled={!piece?.Shape || handleMoveLeftDisabled()}
            onPress={() => handleMoveLeftOnTheKanoodleBoard()}
          >
            Left
          </Button>
        </Grid>
        <Grid md={1}>
          <Button
            auto
            disabled={!piece?.Shape || handleMoveRightDisabled()}
            onPress={() => handleMoveRightOnTheKanoodleBoard()}
          >
            Right
          </Button>
        </Grid>
      </Grid.Container>
      <Grid.Container xl gap={1} justify="center">
        {kanoodleBoard?.map((row) => {
          return row.map((col) => {
            return (
              <Grid
                css={{
                  backgroundColor: col === 0 ? "#120309" : "#D1D5DE",
                  h: "5vw",
                  w: "1vw",
                  border: "1px solid",
                  borderRadius: "30px",
                }}
                xs={1.09}
              >
                &nbsp;
              </Grid>
            );
          });
        })}
      </Grid.Container>
      <br />
      <br />
      <Grid.Container xl gap={1} justify="center">
        <Grid xl={1} justify="center">
          <Button disabled={piece?.Shape ? false: true} auto onPress={() => handleRunCalculation()}>Run Calculations</Button>
        </Grid>
      </Grid.Container>
      <Grid.Container xl gap={1} justify="center">
        <Grid xl={1} justify="center" css={{display:displaySolvableResult ? "block" : "none"}}>
          <Text css={{textAlign:"center"}} h3 color={solvable ? "green": "red"}>{solvable === true ? "This kanoodle is solvable :)" : "this kanoodle is not solvable :(" }</Text>
        </Grid>
      </Grid.Container>
    </Container>
  );
};

function handleInitialApplyPieceShapeToKanoodleBoard(piece_shape) {
  const kanoodle_board = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  ];

  if (piece_shape) {
    kanoodle_board[1][0] = piece_shape[0][0];
    kanoodle_board[1][1] = piece_shape[0][1];
    kanoodle_board[1][2] = piece_shape[0][2];
    kanoodle_board[1][3] = piece_shape[0][3];
    kanoodle_board[2][0] = piece_shape[1][0];
    kanoodle_board[2][1] = piece_shape[1][1];
    kanoodle_board[2][2] = piece_shape[1][2];
    kanoodle_board[2][3] = piece_shape[1][3];
    kanoodle_board[3][0] = piece_shape[2][0];
    kanoodle_board[3][1] = piece_shape[2][1];
    kanoodle_board[3][2] = piece_shape[2][2];
    kanoodle_board[3][3] = piece_shape[2][3];
    kanoodle_board[4][0] = piece_shape[3][0];
    kanoodle_board[4][1] = piece_shape[3][1];
    kanoodle_board[4][2] = piece_shape[3][2];
    kanoodle_board[4][3] = piece_shape[3][3];
  }

  return kanoodle_board;
}
